"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = exports.PROXY_CONTRACT = void 0;
const types_1 = require("../types");
exports.PROXY_CONTRACT = '0xDef1C0ded9bec7F1a1670819833240f027b25EfF';
class Parser {
    parse(tx) {
        if (!tx.tokenTransfers || tx.tokenTransfers.length <= 1)
            return;
        return {
            trade: {
                dexName: types_1.Dex.Zrx,
                type: types_1.TradeType.Trade,
            },
        };
    }
}
exports.Parser = Parser;
